import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import styles from "./SliderValue.module.scss"
import { AtomButtonLabel } from "src/buttons"

export interface Props extends ComponentPropsWithoutRef<"label"> {
  clickable?: boolean;
}

export const SliderValueLabel = forwardRef<HTMLLabelElement, Props>(
  function SliderValueLabel(props: Props, propRef: Ref<HTMLLabelElement>) {
    const {
      clickable,
      ...htmlLabelProps
    } = props

    const className = classNames(
      props.className,
      styles.sliderValueLabel,
      clickable && styles.sliderValueLabelClickable,
    )

    if (clickable) {
      return (
        <AtomButtonLabel
          {...htmlLabelProps}
          htmlFor={props.htmlFor}
          className={className}
          ref={propRef}
        />
      )
    }

    return (
      <label
        {...htmlLabelProps}
        htmlFor={props.htmlFor}
        className={className}
        ref={propRef}
      />
    )
  },
)
